// Google Ads conversion tracking — inert until REACT_APP_GOOGLE_ADS_ID and the
// conversion label envs are set (owner pastes the AW-... values from Google Ads).
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const LEAD_LABEL = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL;
const PURCHASE_LABEL = process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL;

export function initGtag() {
  if (!ADS_ID || typeof document === "undefined" || document.getElementById("gtag-js")) return;
  const s = document.createElement("script");
  s.id = "gtag-js";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);
}

function trackConversion(label, value) {
  if (typeof window === "undefined" || !window.gtag || !ADS_ID || !label) return;
  const payload = { send_to: `${ADS_ID}/${label}` };
  if (value) {
    payload.value = value;
    payload.currency = "USD";
  }
  window.gtag("event", "conversion", payload);
}

export function trackLeadConversion() {
  trackConversion(LEAD_LABEL);
}

export function trackPurchaseConversion(amount) {
  trackConversion(PURCHASE_LABEL, amount);
}
